import script from "./CustomerProgressHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerProgressHistory.vue?vue&type=script&setup=true&lang=js"

import "./CustomerProgressHistory.vue?vue&type=style&index=0&id=75fa467b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75fa467b"]])

export default __exports__